import { render, staticRenderFns } from "./InHouse-Requirements.vue?vue&type=template&id=e47fe38a&"
import script from "./InHouse-Requirements.vue?vue&type=script&lang=js&"
export * from "./InHouse-Requirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports